import React, { ReactNode } from 'react';
import './style.scss';

if (process.env.MAIL_APP_PLATFORM === 'h5') {
    require('./style_h5.scss');
} else {
    require('./style.scss');
}
export interface IWrapper {
    label: string,
    subLabel?: string,
    ActionBtn?: ReactNode,
    SubActionBtn?: ReactNode,
    htmlFor: string,
    required?: boolean,
    extraClass?: string
    id?: string,
    actionPos?: 'top' | 'bottom'
}

const WithLabelAction: React.FC<IWrapper> = ({ children, htmlFor, label,subLabel, ActionBtn, SubActionBtn, required, extraClass, id, actionPos = 'bottom' }) => {
    return (
        <div className={`label-wrapper ${extraClass ? extraClass : ''}`} id={id}>
            <div className="action-bar">
                <label className="label" htmlFor={htmlFor} >{label}{subLabel ? <span style={{color: 'rgba(0, 0, 0, 0.45)', fontWeight: 400}}>{subLabel}</span> : null} {required ? <span className="required-icon">*</span> : ''} </label>
                {SubActionBtn}
                {actionPos === 'top' && <div className="action-btn-wrapper">
                    {ActionBtn}
                </div>}
            </div>
            {children}
            {actionPos === 'bottom' && <div className="action-btn-wrapper">
                {ActionBtn}
            </div>}
        </div>
    )
}

export default WithLabelAction;
